import Footer from './Footer';
import Header from './Header';
import Layout from './Layout';
import PageContent from './PageContent';
import PropTypes from 'prop-types';
import React from 'react';
import {CONTAINER_PADDING_X, CONTAINER_PADDING_Y} from '../utils';
import {Container} from '@chakra-ui/react';
import {Helmet} from 'react-helmet';

export default function PageLayout(props) {
  return (
    <Layout>
      <Helmet title={props.pageContext.frontmatter.title} />
      <Header bg="white" />
      <Container
        py={CONTAINER_PADDING_Y}
        px={CONTAINER_PADDING_X}
        maxW="container.md"
      >
        <PageContent maxW="container.lg">{props.children}</PageContent>
      </Container>
      <Footer />
    </Layout>
  );
}

PageLayout.propTypes = {
  pageContext: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};
